// extracted by mini-css-extract-plugin
export default {"shell":"PageLoader_shell__pBKFP","mark":"PageLoader_mark__h-jgj","spin":"PageLoader_spin__HUQB7"};